import { defineStore } from 'pinia';
import axios from 'axios';
import { setUserToStorage, removeUserFromStorage, setXHeadersLocale, getStorageXHeaders, removeHeadersFromStorage } from '@/helpers/auth';
import { User, UserHeaders } from '@/types/User';

export const useGlobalStore = defineStore('global', {
    state: () => ({
        userData: {} as User | object,
        editPopupState: false,
        resetPasswordPopupState: false,
    }),

    getters: {
        user: state => state.userData,
        isEditPopup: state => state.editPopupState,
        isResetPasswordPopup: state => state.resetPasswordPopupState,
    },

    actions: {
        mutationLoginUser(userData: User) {
            setUserToStorage(userData);
            if (userData.authentication_token) {
                setXHeadersLocale(userData);
            }
            const headersData: UserHeaders | null = getStorageXHeaders();
            if (headersData) {
                axios.defaults.headers.common = {
                    'X-User-Token': headersData.auth_token,
                    'X-User-Email': headersData.auth_email,
                };
            }
            this.userData = userData;
        },

        mutationUnLoginUser() {
            removeUserFromStorage();
            removeHeadersFromStorage();
            delete axios.defaults.headers.common['X-Provider-Toke'];
            delete axios.defaults.headers.common['X-Provider-Name'];
            this.userData = {};
        },

        showResetPasswordPopup(value: boolean) {
            this.resetPasswordPopupState = value;
        },

        showEditUserPopup(value: boolean) {
            this.editPopupState = value;
        },

        actionUserData(userData: User) {
            this.userData = userData;
        },
    },
});
